import { graphql } from "../../gql";

export const startMutation = graphql(`
    mutation AppTaskAiThreadStartMutation($taskId: ID!, $variantId: ID!) {
        taskAiThreadCreate(taskId: $taskId, variantId: $variantId) {
            error
            taskAiThread {
                id
                submittedTaskVariant {
                    id
                    submittedTask {
                        id
                        task {
                            id
                        }
                    }
                }
                aiThreadItems {
                    id
                    type
                    role
                    content
                }
            }
        }
    }
`);

export const continueMutation = graphql(`
    mutation AppTaskAiThreadContinueMutation($threadId: ID!, $input: String!) {
        taskAiThreadContinue(threadId: $threadId, input: $input) {
            error
            taskAiThread {
                id
                aiThreadItems {
                    id
                    type
                    role
                    content
                }
            }
        }
    }
`);
